module.exports = __webpack_public_path__ + "img/2.0ae1d444.png";